$(".image-preview-slider").on("input change", (e)=>{
    const sliderPos = e.target.value;
    // Update the width of the foreground image
    $('.vector-base').css('width', `${sliderPos}%`)
    // Update the position of the slider button
    $('.image-preview-slider-button').css('left', `${sliderPos}%`)
});
// Keep the gallery carousel from swiping while the preview slider is dragged
$(".image-preview-slider").on("touchstart mousedown", (e)=>{
    e.stopPropagation();
});
